import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderService, AuthenticationService, CatalogService, UserService, ListsService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { BasketService } from 'src/app/_services/basket.service';
import { NavigationEnd, Router } from '@angular/router';
import { BasketProduct, PlusiPoints, User, BasketPrice, Product, PaymentData,PaymentParameters, PickUpCenter, UserAddress, ListUserAddress, ScheduleDelivery, Delivery, DeliveryReservation, ScheduleDeliveries } from 'src/app/_models';
import { Location, DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment.prod';
import { FormBuilder, FormGroup, Validators, Form, NgForm } from '@angular/forms';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { UtilsService } from '../../_services';
import { ProductDetailModalComponent } from 'src/app/products/product-detail-modal/product-detail-modal.component';
import { Add2ListModalComponent } from '../user/user-list/add2-list-modal/add2-list-modal.component';
//20250602 axa inici
import { concatMap, switchMap, concat, tap, catchError, delay } from 'rxjs/operators';
//20250602 axa final
import { UserCouponsModalComponent } from '../user/user-coupons/user-coupons-modal/user-coupons-modal.component';
import { LoginAxaErrorModalComponent } from 'src/app/login-axa-error-modal/login-axa-error-modal.component';
import { MessageModalComponent } from 'src/app/message-modal/message-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { error } from 'console';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';


declare const $:any;

@Component({
  selector: 'app-user-cart',
  templateUrl: './user-cart.component.html',
  styleUrls: ['./user-cart.component.css']
})
export class UserCartComponent implements OnInit {

  public currentStep: number;
  public user: User;
  public plusiPoints: PlusiPoints;
  public HasPlusiPoints: boolean = false;
  public date: Date;
  public basketPrice: BasketPrice;
  public plannedOrder: boolean;

  public submitted: boolean;
  public sendToForm: FormGroup;
  public bagsForm: FormGroup;
  public paymentMethodForm: FormGroup;
  public paymentData: PaymentData;
  public sendTo: string;

  public pickupCenterForm: FormGroup;
  public selectedCenter: PickUpCenter;

  public addressForm: FormGroup;
  public userAddresses: ListUserAddress[];
  public selectedAddress: UserAddress;

  public planningForm: FormGroup;
  private scheduleDeliveries: ScheduleDeliveries;
  public scheduleHours: ScheduleDelivery[];
  public selectedHourRange: number;
  public delivery: Delivery;
  public refreshing: boolean = false;
  public debouncer: any;
  public paymentMethod: string = '';
  private isProcessing = false;

  @ViewChild(ProductDetailModalComponent) productDetailModal: ProductDetailModalComponent;
  @ViewChild(Add2ListModalComponent) add2ListModal: Add2ListModalComponent;
  @ViewChild(UserCouponsModalComponent) userCouponsModal: UserCouponsModalComponent;
  @ViewChild(MessageModalComponent) messageModal: MessageModalComponent;
  @ViewChild(LoginAxaErrorModalComponent) axaErrorModal: LoginAxaErrorModalComponent;
  constructor(
    public header: HeaderService,
    public auth: AuthenticationService,
    public translate: TranslateService,
    public basket: BasketService,
    public router: Router,
    public catalog: CatalogService,
    public users: UserService,
    public location: Location,
    public spinner: NgxSpinnerService,
    public formBuilder: FormBuilder,
    public dom: DomSanitizer,
    public utils: UtilsService,
    public listss: ListsService,
    public datePipe: DatePipe,
    private titles: Title,
    private cdRef: ChangeDetectorRef
  ) {

    this.header.setHeader(false, false, true, true);

    this.basket.basketPrice.subscribe(bp => {
      this.basketPrice = bp;
      setTimeout(() => {
        this.spinner.hide('basketSpinner');
        $(document).trigger('equalizeCart');
      }, environment.READY_TIMEOUT);
    });
  }


  ngOnInit() {
    this.currentStep = 1;
    this.sendTo = '';
    this.submitted = false;
    this.selectedAddress = null;
    this.selectedCenter = null;

    // /////   TEST
    // this.currentStep = 2;
    // this.sendTo = 'center';
    // /////   END TEST

    setTimeout(() => {
      this.spinner.show('basketSpinner');
    }, environment.READY_TIMEOUT);


    this.sendToForm = this.formBuilder.group({
      sendTo: ['', Validators.required],
    });

    this.bagsForm = this.formBuilder.group({
      bolsas: ['', Validators.required]
    });

    this.paymentMethodForm = this.formBuilder.group({
      paymentMethod: ['', Validators.required]
    });
    this.pickupCenterForm = this.formBuilder.group({
      centerid: ['', Validators.required]
    });

    this.addressForm = this.formBuilder.group({
      recid: ['', Validators.required]
    });

    this.planningForm = this.formBuilder.group({
      date: [, Validators.required],
      hourRange: [, Validators.required],
      observ: []
    });

    this.auth.currentUser.subscribe(user => {
      this.user = user;

      if (user) {
        this.refreshPoints();
        this.f1.bolsas.setValue(this.user.nobags.toString());
        //20250602 axa inici
        if (this.auth.isAxA) {
          this.sendToForm.disable();
        }
        //20250602 axa final
        this.userAddresses = this.user.user_addresses.filter(address => {
          return address.address_type == 2 && (address.centre_ClickRecull == '' || address.centre_ClickRecull == null)
        });

        let primaryAddress = this.user.user_addresses.find(address => {
          return address.isprimary == 1;
        });

        if (primaryAddress.centre_ClickRecull == null || primaryAddress.centre_ClickRecull.trim() == '') {
          this.f2.sendTo.setValue('address', { onlySelf: true, emitEvent: false });
        }

        if (primaryAddress.centre_ClickRecull && primaryAddress.centre_ClickRecull != null) {
          this.f2.sendTo.setValue('center', { onlySelf: true, emitEvent: false });
        }

        this.basket.delivery.subscribe(result => {
          this.plannedOrder = result == null ? false : true;
          this.delivery = result;
          if (this.plannedOrder) {
            if (this.delivery.tipo == 1) {
              this.f2.sendTo.setValue('address', { onlySelf: true, emitEvent: false });
            }
            else {
              this.f2.sendTo.setValue('center', { onlySelf: true, emitEvent: false });
            }
            this.refreshDeliverySchedule(this.delivery)
          }
        });


      }

      this.initStep();
    });

    this.translate.get('CART_TITLE').subscribe(translation => {
      this.titles.setTitle(translation);
    });

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.basket.setCheckOut(false);
      }
    });

  }

  get f1() {
    return this.bagsForm.controls;
  }

  get f2() {
    return this.sendToForm.controls;
  }

  get f3() {
    return this.pickupCenterForm.controls;
  }

  get f4() {
    return this.addressForm.controls;
  }

  get f5() {
    return this.planningForm.controls;
  }

  refreshPoints() {
    if (this.user.get_plusi_card == 0) {
      this.users.getPromoPoints().subscribe(
        result => {
          this.plusiPoints = result;
          if (this.plusiPoints.plusi_points > 0) this.HasPlusiPoints = true;
        }, error => {
          this.plusiPoints = null;
          this.HasPlusiPoints = false;
        });
    }
  }

  clearBasket() {
    this.basket.empty().subscribe();
  }

  more(bProduct: BasketProduct) {
    if (bProduct.product.has_format) {
      this.basket.moreFormat(bProduct).subscribe();
    } else {
      this.basket.more(bProduct.product).subscribe();
    }
  }

  less(bProduct: BasketProduct) {
    if (bProduct.product.has_format) {
      this.basket.lessFormat(bProduct).subscribe();
    } else {
      this.basket.less(bProduct.product).subscribe();
    }
  }

  updateQuantity(bProduct: BasketProduct, target: any): any {
    clearTimeout(this.debouncer);
    this.debouncer = setTimeout(() => {
      this.basket.setQuantity(bProduct.product, target.value).subscribe(result => {
        target.value = bProduct.quantity;
      });
    }, environment.UPDATE_QTY_TIMEOUT);

    return this.debouncer;

  }

  immediateUpdateQuantity(bProduct: BasketProduct, target: any): any {
    clearTimeout(this.debouncer);
    this.basket.setQuantity(bProduct.product, target.value).subscribe(result => {
      target.value = bProduct.quantity;
    });
  }


  remove(bProduct: BasketProduct) {
    this.basket.remove(bProduct).subscribe(result => {
    });

  }

  back() {
    this.location.back();
  }

  showCoupons() {
    this.userCouponsModal.show()
  }

  getNotification(event: any) {
    // it's done on applycoupons button
    // this.basket.get().subscribe();
  }

  productDetail(itemId: string) {
    $('#modal-product-detail').modal('show');
    this.productDetailModal.itemId = itemId;
    this.productDetailModal.loadData();
  }

  onConfirmEmpty(event: any) {
    this.basket.empty().subscribe(result => {
      this.header.scrollTop();
    });

  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep -= 1;
      this.header.scrollTop();
    }
    else {
      this.back()
    }
    //20250602 axa inici
    // si es compra express salta el pas de seleccio de franja horaria
    if (this.currentStep == 2 && this.auth.isAxA) {
      this.currentStep -= 1;
    }
    //20250602 axa final

    this.initStep();
  }

  nextStep() {

    this.submitted = true;

    if (!this.validateStep()) {
      return;
    }

    // Next step
    if (this.currentStep < 3) {
      this.submitted = false;
      this.currentStep += 1;
      this.header.scrollTop();
    }
    //20250602 axa inici
    // si es compra express salta el pas de seleccio de franja horaria
    if (this.currentStep == 2 && this.auth.isAxA) {
      this.currentStep += 1;
    }
    //20250602 axa final

    this.initStep();
  }

  async validateStep() {
    switch (this.currentStep) {
      case 1:
        this.sendTo = this.f2.sendTo.value;
        return !(this.sendToForm.invalid || this.bagsForm.invalid);
      case 2:
        this.addressForm.updateValueAndValidity();
        this.planningForm.updateValueAndValidity();
        this.pickupCenterForm.updateValueAndValidity();
        if (this.sendTo == 'address') {
          return !(this.planningForm.invalid || this.addressForm.invalid);
        }
             

        return !(this.planningForm.invalid || this.pickupCenterForm.invalid);
      default:
        return true;
    }
  }

  async initStep() {
    this.basket.setCheckOut(this.currentStep > 1);

    switch (this.currentStep) {
      case 1:
        break;
      case 2:
        this.setDate("");
        this.setDatePicker();

        let primaryAddress = this.user.user_addresses.find(address => {
          return address.isprimary == 1;
        });


        // if primary address is not a click&Recull, select this address
        if (this.sendTo == 'address' && (primaryAddress.centre_ClickRecull == null || primaryAddress.centre_ClickRecull.trim() == '')) {
          this.f4.recid.setValue(primaryAddress.recid, { onlySelf: true, emitEvent: false });
          this.onSelectAddress(false);
        }


        // if primary address is click&Recull, select this address
        if (this.sendTo == 'center' && primaryAddress.centre_ClickRecull != null) {
          this.f3.centerid.setValue(primaryAddress.centre_ClickRecull, { onlySelf: true, emitEvent: false });

          this.onSelectPickupCenter(false);
        }

        if (this.delivery) {
          if (this.delivery.tipo == 1 && this.sendTo == 'address') {
            this.f4.recid.setValue(this.delivery.id_tipo, { onlySelf: true, emitEvent: false });
            this.onSelectAddress(false);
          } else if (this.delivery.tipo == 2 && this.sendTo == 'center') {

            this.f3.centerid.setValue(this.delivery.id_tipo, { onlySelf: true, emitEvent: false });
            this.onSelectPickupCenter(false);
          }
        }

        this.refreshDeliverySchedule(this.delivery);
        break;

      case 3:
        this.refreshing = true;
        this.basketPrice = null;

        if (this.isProcessing) return; // ya está en curso

        //20250602 axa inici
        // si es compra expresss no cal guardar la planificaciÃ³.
        if (!this.auth.isAxA) {
          //20250602 axa final
          this.refreshing = true;
          let modalShown = false;
          this.isProcessing = true;

          this.saveDeliveryPlanning().pipe(
            switchMap(() => this.basket.getPSD2()),
            switchMap(async () => {
              this.paymentData = new PaymentData();
              this.paymentData.parameters = new PaymentParameters();
              this.cdRef.detectChanges();

              const errorMessages = await this.limpiarCesta(this.auth.isAxA, false);
              return errorMessages;
            })
          ).subscribe({
            next: (errorMessages) => {

                this.refreshing = false;
                this.isProcessing = false;
              if (errorMessages && !modalShown) {
                modalShown = true; // evita que se muestre dos veces

                const errorTitle = this.translate.instant('BUYAXA.DELIVERY_ERROR');
                this.axaErrorModal.show(errorTitle, errorMessages);

                this.axaErrorModal.close.pipe(take(1)).subscribe(async (result) => {
                  if (result) {
                    await this.limpiarCesta(this.auth.isAxA, true);
                  }

                  this.currentStep = 1;
                  this.router.navigate(['/user/cart/']);
                });
              }
            },
            error: () => {
              this.refreshing = false;
              this.isProcessing = false;
            }
          });


          /* this.saveDeliveryPlanning().subscribe(r=>{
             this.basket.get().subscribe(rr=>{
           
               this.paymentData = new PaymentData(); //Vacío para mostrar el form.
               this.paymentData.parameters = new PaymentParameters();
               this.refreshing = false;
             }, ee=> {
               this.refreshing=false;
             });
           },e =>{
             this.refreshing=false;
           });*/

          //20250602 axa inici
        } else {
          this.basket.getPSD2().subscribe(rr => {
            this.paymentData = new PaymentData(); //Vacío para mostrar el form.
            this.paymentData.parameters = new PaymentParameters();
            this.refreshing = false;
          }, ee => {
            this.refreshing = false;
          });
        }

        //20250602 axa final

        //await new Promise(resolve => setTimeout(resolve, 1000));

       


        break;
      default:
    }
  }

  /**
   * Ocurre al pulsar el boton efectuar pago
   *
   * @param {*} formPayment
   * @memberof UserCartComponent
   */
  submitPayment(formPayment: any) {
    let paymentMethod = this.paymentMethodForm.get('paymentMethod').value;
    this.refreshing = true;

    this.basket.getPaymentData(paymentMethod).subscribe(result => {
      this.paymentData = result;

      formPayment.elements.Ds_SignatureVersion.value = result.parameters.Ds_SignatureVersion;
      formPayment.elements.Ds_MerchantParameters.value = result.parameters.Ds_MerchantParameters;
      formPayment.elements.Ds_Signature.value = result.parameters.Ds_Signature;

      formPayment.action = result.URL;
      formPayment.method = result.verb;

      formPayment.submit();
      this.refreshing = false;
    });

  }


  /**
   * Ocurre cuando se selecciona una opción del formlario de bolsas
   *
   * @memberof UserCartComponent
   */
  setBagsOption() {
    this.basket.setBagsOption(this.bagsForm.controls.bolsas.value).subscribe();
  }

  onSelectSendTo() {
    this.sendTo = this.f2.sendTo.value;
    this.refreshDeliverySchedule();
  }

  onSelectAddress(message: boolean) {

    this.selectedAddress = this.user.user_addresses.find(address => {
      return address.recid == this.f4.recid.value;
    });

    if (message) {
      this.refreshDeliverySchedule();
    }

    if (message && this.selectedAddress && this.user.subst_policy == 0) {
      $('#modal-message-ChangeAddress').modal('show');
    }
  }

  onSelectPickupCenter(message: boolean) {
    this.selectedCenter = this.utils.pickupCenters.find(center => {
      return center.centerid == this.f3.centerid.value;
    });

    this.refreshDeliverySchedule();
    if (message && this.selectedCenter && this.user.subst_policy == 0) {
      $('#modal-message-ChangeAddress').modal('show');
    }

  }

  setDatePicker() {
    setTimeout(() => {
      $('.datepicker').datepicker('destroy');
      $('.datepicker').datepicker({
        autoclose: true,
        language: this.translate.currentLang,
        keyboardNavigation: false,
        forceParse: false,
        beforeShowDay: (sDate: Date) => { return this.isAvailableDate(sDate); }
      })
        .on('changeDate', (e: any) => { this.onChangeDate(e); });
    }, environment.READY_TIMEOUT);
  }

  setDate(date: string, delivery?: Delivery) {
    let range: string = '';

    if (delivery) {
      date = delivery.transdate;
    }
    this.f5.date.setValue(date, { onlySelf: true, emitEvent: false });

    if (this.scheduleDeliveries) {
      this.scheduleHours = this.scheduleDeliveries.hours(date);
    } else {
      this.scheduleHours = null;
    }
    if (delivery) {
      range = this.scheduleHours.indexOf(this.scheduleHours.find(schedule => {
        return schedule.fromtime == delivery.fromtime && schedule.totime == delivery.totime;
      })).toString();
      this.f5.hourRange.setValue(range, { onlySelf: true, emitEvent: false });
    }

  }

  refreshDeliverySchedule(delivery?: Delivery) {

    const deliveryType: number = this.sendTo == 'address' ? 1 : 2;
    const deliveryId: number = this.sendTo == 'address' ? this.f4.recid.value : this.f3.centerid.value;
    let pickupCenter = this.utils.pickupCenters.find((p) => p.centerid.trim() === deliveryId.toString());
    let tiporecogida: number = this.sendTo == 'address' ? 0 : (pickupCenter ? +pickupCenter.TipoRecogida : 0);
    this.setDatePicker();

    if (deliveryId && deliveryId != 0) {
      this.basket.getAvailableSchedule(deliveryType, deliveryId, tiporecogida).subscribe(
        result => {

          this.scheduleDeliveries = result;
          $('.datepicker').datepicker('update');

          if (delivery) {
            let found: boolean = false;
            this.f5.observ.setValue(delivery.observacions, { onlySelf: true, emitEvent: false });
            this.f5.date.setValue(delivery.transdate, { onlySelf: true, emitEvent: false });

            if (this.scheduleDeliveries) {
              this.scheduleHours = this.scheduleDeliveries.hours(delivery.transdate);
            } else {
              this.scheduleHours = null;
            }

            if (this.scheduleHours) {
              this.scheduleHours.forEach((sched, ind) => {
                if (delivery.fromtime === sched.fromtime) {
                  found = true;
                }
              });

              // Si ya no esta disponible el horario, lo añade (pués esta planificado)
              if (!found) {
                let schedule: ScheduleDelivery = new ScheduleDelivery();
                schedule.fromtime = delivery.fromtime;
                schedule.totime = delivery.totime;
                schedule.transdate = delivery.transdate;
                schedule.id_tipo = delivery.id_tipo;
                this.scheduleHours.push(schedule);

                this.scheduleHours.sort((a, b) => {
                  return a.fromtime.localeCompare(b.fromtime);
                })
              }


              this.scheduleHours.forEach((sched, ind) => {
                if (delivery.fromtime === sched.fromtime) {
                  this.selectedHourRange = ind;
                  this.f5.hourRange.setValue(ind, { onlySelf: true, emitEvent: false });
                }
              });
            }
          } else {
            this.f5.observ.setValue('', { onlySelf: true, emitEvent: false });
            this.f5.date.setValue('', { onlySelf: true, emitEvent: false });
            this.f5.hourRange.setValue('', { onlySelf: true, emitEvent: false });
          }
        },
        error => {
          this.scheduleDeliveries = null;
          $('.datepicker').datepicker('update');
          this.setDate('');
        }
      );
    } else {
      this.scheduleDeliveries = null;
      $('.datepicker').datepicker('update');
      this.setDate('');
    }


  }

  isAvailableDate(sDate: Date) {

    if (!this.scheduleDeliveries)
      return false;

    if (this.scheduleDeliveries.contains(this.datePipe.transform(sDate, 'dd/MM/yyyy'))) {
      return { enabled: true, classes: 'available' };
    }


    return { enabled: false };

  }

  saveDeliveryPlanning() {

    let reservation: DeliveryReservation = new DeliveryReservation();
    reservation.tipo = this.sendTo == 'address' ? 1 : 2;
    reservation.id_tipo = this.sendTo == 'address' ? this.selectedAddress.recid : this.selectedCenter.centerid;
    reservation.transdate = this.f5.date.value;
    reservation.fromtime = this.scheduleHours[this.f5.hourRange.value].fromtime;
    reservation.totime = this.scheduleHours[this.f5.hourRange.value].totime;
    reservation.observacions = this.f5.observ.value;
    let pickupCenter = this.utils.pickupCenters.find((p) => p.centerid.trim() === reservation.id_tipo.toString());
    reservation.tiporecogida = this.sendTo == 'address' ? 0 : (pickupCenter ? +pickupCenter.TipoRecogida : 0);
    return this.basket.setDelivery(reservation);
  }

  onChangeDate(e?: any) {
    if (e) {
      this.setDate(this.datePipe.transform(e.date, "dd/MM/yyyy"));
    } else {
      this.setDate(this.f5.date.value);
    }
  }

  add2List(bProduct: BasketProduct) {
   // console.log("user-cart", bProduct)
    this.add2ListModal.product = bProduct;
    $('#modal-add2-list').modal('show');
  }

  setPaymentMethod(value: string) {
    this.paymentMethod = value;
  }



  async limpiarCesta(isAxA: boolean, isSilenceCorrection: boolean) {
    //console.log("Antes de SilenceCleanBasket");

    try {
      const res = await this.basket.SilenceCleanBasket(isAxA, isSilenceCorrection).toPromise();
    //  console.log("Después de SilenceCleanBasket", res);

      if (isSilenceCorrection) {
     //  console.log("Corrección silenciosa iniciada");

        of(null).pipe(
          tap(() => console.log('get')),
          concatMap(() => this.basket.get()),

          tap(() => console.log('getdelivery')),
          concatMap(() => this.basket.getDelivery()),

          tap(() => console.log('totals')),
          concatMap(() => this.basket.total())
        ).subscribe({
          next: (result) => console.log('resultat parcial', result),
          error: (err) => console.error('error!', err),
          complete: () => console.log('Totes les operacions completades'),
        });
      }

      return res;

    } catch (err) {
      console.error("Error SilenceCleanBasket", err);

      if (err instanceof HttpErrorResponse) {
        console.error('Error al limpiar la cesta', err.status, err.error);
        return err.error;
      }

      if (err && err.error && err.length > 0) {
        // el backend manda [{ conflict_message: "..."}]
        return err.error;
      }

      throw err; // cualquier otro error inesperado
    }
  }
}
